import {
  audioVuexStore,
  chatVuexStore,
  indexVuexStore,
  requestsVuexStore,
  shiftsVuexStore,
  websocketVuexStore,
  adminactivitiesVuexStore,
  adminblockedIdentifiersVuexStore,
  adminoperatorsVuexStore,
  adminratingsVuexStore,
  adminshiftsVuexStore,
  adminusersVuexStore,
  clientcontactsVuexStore,
  clientemployeesVuexStore,
  clientrequestsVuexStore,
  operatorclientsVuexStore,
  operatorequipVuexStore,
  operatornotesVuexStore,
  operatoroperatorsVuexStore,
  operatororganizationsVuexStore,
  operatorrequestsVuexStore,
  operatorshiftsVuexStore,
  operatorusersVuexStore 
} from "#imports"
const VuexStore = {
  ...indexVuexStore,
  modules: {
      'audio': {
        ...audioVuexStore.default ?? audioVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'chat': {
        ...chatVuexStore.default ?? chatVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'requests': {
        ...requestsVuexStore.default ?? requestsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'shifts': {
        ...shiftsVuexStore.default ?? shiftsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'websocket': {
        ...websocketVuexStore.default ?? websocketVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'admin': {
        
        namespaced: true,
        modules: {
      'activities': {
        ...adminactivitiesVuexStore.default ?? adminactivitiesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'blockedIdentifiers': {
        ...adminblockedIdentifiersVuexStore.default ?? adminblockedIdentifiersVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'operators': {
        ...adminoperatorsVuexStore.default ?? adminoperatorsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'ratings': {
        ...adminratingsVuexStore.default ?? adminratingsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'shifts': {
        ...adminshiftsVuexStore.default ?? adminshiftsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'users': {
        ...adminusersVuexStore.default ?? adminusersVuexStore,
        namespaced: true,
        modules: {},
      }
    },
      }
    ,
      'client': {
        
        namespaced: true,
        modules: {
      'contacts': {
        ...clientcontactsVuexStore.default ?? clientcontactsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'employees': {
        ...clientemployeesVuexStore.default ?? clientemployeesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'requests': {
        ...clientrequestsVuexStore.default ?? clientrequestsVuexStore,
        namespaced: true,
        modules: {},
      }
    },
      }
    ,
      'operator': {
        
        namespaced: true,
        modules: {
      'clients': {
        ...operatorclientsVuexStore.default ?? operatorclientsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'equip': {
        ...operatorequipVuexStore.default ?? operatorequipVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'notes': {
        ...operatornotesVuexStore.default ?? operatornotesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'operators': {
        ...operatoroperatorsVuexStore.default ?? operatoroperatorsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'organizations': {
        ...operatororganizationsVuexStore.default ?? operatororganizationsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'requests': {
        ...operatorrequestsVuexStore.default ?? operatorrequestsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'shifts': {
        ...operatorshiftsVuexStore.default ?? operatorshiftsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'users': {
        ...operatorusersVuexStore.default ?? operatorusersVuexStore,
        namespaced: true,
        modules: {},
      }
    },
      }
    }, 
  }
export default VuexStore